import Card from '../Card'
import { createUseStyles } from 'react-jss'
import { Colors } from '../../constants/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { PayrollCodeConfigurationModel } from '../../redux/types'

interface Props {
  payrollCodes: PayrollCodeConfigurationModel[]
  onDeleteClick?: (creditor: PayrollCodeConfigurationModel) => void
}

const PayrollCodeList = ({ onDeleteClick, payrollCodes }: Props) => {
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <Card className={`${styles.container} ${styles.header} card`}>
        <div className={styles.cell}>
            <p><span>Type</span></p>
        </div>
        <div className={styles.cell}>
            <p><span>Code</span></p>
        </div>
        <div className={styles.cell}>
            <p><span>Value source</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Value</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Negate</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Incl. id number</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Incl. name</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Incl. from date</span></p>
        </div>
        <div className={styles.cell}>
          <p><span>Incl. to date</span></p>
        </div>
        <div className={`${styles.cell} ${styles.deleteButtonCell}`}>
        </div>
    </Card>
    )    
  }

  const renderListItems = () => {
    return payrollCodes?.map((item, index) => {
      return (
        <Card className={`${styles.container} card`} key={`payrollCode_${index}`}>
          <div className={styles.cell}>
              <p>{item.type}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.code}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.valueSource}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.value}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.negate ? "yes" : "no"}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.includeIdentificationNumber ? "yes" : "no"}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.includeName ? "yes" : "no"}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.includeFromDate ? "yes" : "no"}</p>
          </div>
          <div className={styles.cell}>
              <p>{item.includeToDate ? "yes" : "no"}</p>
          </div>
          <div className={`${styles.cell} ${styles.deleteButtonCell}`}>
              <FontAwesomeIcon
                  className={styles.button}
                  icon={faTrashAlt}
                  color={Colors.euro_600}
                  title='Delete'
                  onClick={() => onDeleteClick && onDeleteClick(item)}
              />
          </div>
      </Card>
      )
    })
  }

  return (
    <div>
      {renderHeader()}
      {renderListItems()}
    </div>
  )
}

export default PayrollCodeList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 3px',
    margin: '5px 0',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: Colors.darkGrayHover,
    }
  },
  header: {
    margin: '10px 0 5px 0',
  },
  '& p': {
      fontSize: 12,
      margin: 0,
      '& span': {
        fontFamily: 'Aestetico-Bold',
        color: Colors.euro_600,
      }
  },
  flagged: {
      backgroundColor: Colors.red,
  },
  cell: {
    flex: 1,
    padding: '0px 5px'
  },
  deleteButtonCell: {
    textAlign: 'center',
    flex: '0 0 40px'
  },
  button: {
      transition: '0.4s',
      '&:hover': {
        color: Colors.euro5,
        cursor: 'pointer',
      }
    },
})
